module.exports = __webpack_public_path__ + "static/media/educationBag.5c5e75be.svg";